import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { BzgModalRef, BzgModalService } from 'bz-genome-angular';
import { SyncFilesService } from './services/sync-files.service';

@Component({
  selector: 'biz-sync-files',
  templateUrl: './sync-files.component.html',
  styleUrls: ['./sync-files.component.scss']
})
export class SyncFilesComponent implements OnInit{

  @ViewChild('exportTemplate') exportTemplate: TemplateRef<any>;

  private modalExport: BzgModalRef;
  exportHistory: any;

  constructor(private _modalService: BzgModalService,
    private _syncFilesService: SyncFilesService) { }


  ngOnInit(): void {
    this.getExportHistory();
  }

  onExport(){
    this.modalExport = this._modalService.open(this.exportTemplate, { 
      closeOnBackdropClick: false, closeOnRouterNavigation: true, maxWidth: '1000px'
    });
  }

  public closeModalExport() {
    this.getExportHistory();
    this.modalExport.close();
  }

  private getExportHistory() {
    this._syncFilesService.getExportHistory().then(data => {
      this.OrderHistory(data);
      this.exportHistory = data.map(item => {
        let showDetail;
        try {
          JSON.parse(item.errorLog);
          showDetail = true;
        } catch (error) {
          showDetail = false;
        }

        return {
          ...item,
          showDetail: showDetail,
          detailExpanded: false
        };
      });
    });
  }

  private OrderHistory(data: any) {
    return data.sort((a, b) => {
      return new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime();
    });
  }
}
